import { render } from "./loginView.vue?vue&type=template&id=0ac1d198&scoped=true&ts=true"
import script from "./loginView.vue?vue&type=script&lang=ts"
export * from "./loginView.vue?vue&type=script&lang=ts"

import "./loginView.vue?vue&type=style&index=0&id=0ac1d198&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac1d198"]])

export default __exports__